export default __webpack_public_path__ + "4ff18fa72bd90514e470e2a06daa4a8a.woff2";